import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { LoginFormModule } from '@libs/src/login-form/login-form.module';
import { SsoSigninModule } from '@libs/src/sso-signin/sso-signin.module';
import { TrackClickModule } from '@libs/src/track-click/track-click.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { LocalizationDropDownModule } from '@main-client/src/app/localization-drop-down/localization-drop-down.module';
import { NoLocalStoragePromptModule } from '@main-client/src/app/no-local-storage-prompt/no-local-storage-prompt.module';
import { OnboardingBackgroundFlairModule } from '@main-client/src/app/onboarding-background-flair/onboarding-background-flair.module';
import { LiveTranslateModule } from '@main-client/src/app/pipes/live-translate/live-translate.module';
import { TextToPossessivePipeModule } from '@main-client/src/app/pipes/text-to-possessive-pipe/text-to-possessive-pipe.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';
import { SignUpBannerModule } from '@main-client/src/app/sign-up-banner/sign-up-banner.module';
import { SignUpEventBannerModule } from '@main-client/src/app/sign-up-event-banner/sign-up-event-banner.module';

import { PreRegistrationBackend } from '@libs/src/pre-registration/pre-registration.backend';
import { ProgramMembershipsBackend } from '@libs/src/program-memberships/program-memberships.backend';

import { SignUpViewComponent } from './sign-up-view.component';
import { SignUpComponent } from './sign-up.component';

import { InviteCodeResolver } from '@main-client/src/app/sign-up/invite-code.resolver';
import { PathwayMembershipResolver } from '@main-client/src/app/sign-up/pathway-membership.resolver';
import { PreRegistrationResolver } from '@main-client/src/app/sign-up/pre-registration.resolver';
import { ProgramMembershipResolver } from '@main-client/src/app/sign-up/program-membership.resolver';

@NgModule({
  declarations: [SignUpComponent, SignUpViewComponent],
  imports: [
    AvatarModule,
    CommonModule,
    DialogConfirmPromptModule,
    FlexLayoutModule,
    FormsModule,
    LiveTranslateModule,
    LocalizationDropDownModule,
    LoginFormModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    NoLocalStoragePromptModule,
    NzCheckboxModule,
    NzFormModule,
    NzInputModule,
    NzSelectModule,
    OnboardingBackgroundFlairModule,
    ProgressSpinnerModule,
    RouterModule.forChild([
      {
        component: SignUpViewComponent,
        data: { hideHelp: true },
        path: '',
        resolve: {
          invitation: InviteCodeResolver,
          pathwayMembership: PathwayMembershipResolver,
          preRegistration: PreRegistrationResolver,
          programMembership: ProgramMembershipResolver,
        },
      },
    ]),
    ReactiveFormsModule,
    SignUpBannerModule,
    SignUpEventBannerModule,
    SsoSigninModule,
    TextToPossessivePipeModule,
    TrackClickModule,
    TtcButtonSharedModule,
    TtcMatInputModule,
  ],
  providers: [
    InviteCodeResolver,
    PathwayMembershipResolver,
    PreRegistrationBackend,
    PreRegistrationResolver,
    ProgramMembershipResolver,
    ProgramMembershipsBackend,
  ],
})
export class SignUpModule {}
